export default __webpack_public_path__ + "static/media/providers-header.a5f15b38.png";